
import {Grid, Typography} from "@mui/material";
import tecnologias1 from "../../../Recursos/tecnologias1.png";
import tecnologias2 from "../../../Recursos/tecnologias2.png";
import tecnologias3 from "../../../Recursos/tecnologias3.png";
import tecnologias4 from "../../../Recursos/tecnologias4.png";
import tecnologias5 from "../../../Recursos/tecnologias5.png";
import tecnologias6 from "../../../Recursos/tecnologias6.png";
import tecnologias7 from "../../../Recursos/tecnologias7.png";
import tecnologias8 from "../../../Recursos/tecnologias8.png";
import tecnologias9 from "../../../Recursos/tecnologias9.png";
import tecnologias10 from "../../../Recursos/tecnologias10.png";
import tecnologias11 from "../../../Recursos/tecnologias11.png";
import tecnologias12 from "../../../Recursos/tecnologias12.png";

export const tecnologias = [
    {
        titulo: "JavaScript",
        imagen: tecnologias1
    },
    {
        titulo: "React",
        imagen: tecnologias2
    },
    {
        titulo: "Material UI",
        imagen: tecnologias3
    },
    {
        titulo: "Tailwind CSS",
        imagen: tecnologias4
    },
    {
        titulo: "SEO",
        imagen: tecnologias5
    },
    {
        titulo: "Node.js",
        imagen: tecnologias6
    },
    {
        titulo: "Express",
        imagen:tecnologias7
    },
    {
        titulo: "Firebase",
        imagen: tecnologias8
    },
    {
        titulo: "MongoDB",
        imagen:tecnologias9
    },
    {
        titulo: "Figma",
        imagen: tecnologias10
    },
    {
        titulo: "Illustrator",
        imagen: tecnologias11
    },
    {
        titulo: "Photoshop",
        imagen: tecnologias12
    },
];

const Lista_Tecnologias_Nosotros = () => {

    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'flex-start'}
            spacing={2}
            size={{xs: 12, sm: 12, md: 12}}>


                {tecnologias.map((tech, index) => (
                    <Grid item xs={6} sm={4} md={3} key={index} display="flex" flexDirection="column" alignItems="center">
                        <img
                            height="60"
                            src={tech.imagen}
                            alt={tech.titulo}
                        />
                        <Typography variant="body1" fontWeight="500" mt={1}>
                            {tech.titulo}
                        </Typography>
                    </Grid>
                ))}

        </Grid>
    )

}
export default Lista_Tecnologias_Nosotros